import ResponsiveSSR from '@pretto/bricks/components/utility/ResponsiveSSR'

export const amount = {
  default: 100000,
  description: 'Prix de vente du bien, travaux inclus.',
  label: 'Prix du bien',
  max: 500000,
  min: 50000,
  placeholder: '',
  step: 1000,
  suffix: '€',
}

export const duration = {
  default: 25,
  description: 'Nombre d’années pour rembourser votre prêt.',
  label: 'Durée du prêt',
  max: 25,
  min: 10,
  step: 5,
  suffix: 'ans',
}

export const initialDuration = {
  ...duration,
  default: null,
  label: (
    <>
      Durée <ResponsiveSSR min="mobileL">initiale </ResponsiveSSR>du prêt
    </>
  ),
  placeholder: '0',
}

export const numberMortgagors = {
  default: 1,
  label: 'Emprunteur(s)',
  options: [
    { id: '1', label: 'Seul', value: '1' },
    { id: '2', label: 'À deux', value: '2' },
  ],
}

export const income = {
  description: 'Le total des revenus mensuels nets avant impôts du foyer.',
  label: 'Revenus',
  max: 15000,
  min: 0,
  placeholder: 'ex : 2 000',
  step: 100,
  suffix: '€ / mois',
}

export const totalIncome = {
  ...income,
  label: (
    <>
      Revenus<ResponsiveSSR min="tablet"> du foyer</ResponsiveSSR>
    </>
  ),
  placeholder: '0',
}

export const contribution = {
  description: 'Le montant dont vous disposez pour financer votre projet.',
  label: 'Apport',
  max: 200000,
  min: 0,
  placeholder: 'ex : 10 000',
  step: 1000,
  suffix: '€',
}

export const payment = {
  description: 'Votre mensualité actuelle, hors assurance.',
  label: (
    <>
      Mensualité<ResponsiveSSR min="tablet"> actuelle</ResponsiveSSR>
    </>
  ),
  max: 5000,
  min: 0,
  placeholder: '0',
  step: 100,
  suffix: '€ / mois',
}

export const initialRate = {
  description: 'Le taux actuel de votre prêt.',
  label: (
    <>
      Taux d'intérêt<ResponsiveSSR min="mobileL"> initial</ResponsiveSSR>
    </>
  ),
  max: 5,
  min: 0.1,
  placeholder: '0',
  step: 0.01,
  suffix: '%',
}

export const signatureDate = {
  description: 'Date à laquelle vous avez signé l’offre de prêt.',
  label: (
    <>
      <ResponsiveSSR min="mobileL">Date de </ResponsiveSSR>signature
    </>
  ),
}
